import { JustpayRemainderEndpointService } from "@/views/loyalty/shared/endpoint_services/justpay-remainder-endpoint-service"

export class JustpayRemainderService {
    constructor () {
        this.justpayRemainderEndpointService = new JustpayRemainderEndpointService()
    }

    async getInit () {
        return this.justpayRemainderEndpointService.getInit()
    }

    async getReport (arg) {
        return this.justpayRemainderEndpointService.getReport(arg)
    }
}
